export default __webpack_public_path__ + "static/media/sd_ticket_banner.870d7410.png";